import {GeneralAnnouncementDto, UserNotificationDto} from '../../../types/notifications.type';
import {createStore, withProps} from '@ngneat/elf';

export interface NotificationsState {
  personalNotifications: UserNotificationDto[];
  generalAnnouncements: GeneralAnnouncementDto[];
  isLoading: boolean;
}

export function createInitialNotificationsState(): NotificationsState {
  return {
    personalNotifications: [],
    generalAnnouncements: [],
    isLoading: false,
  };
}

export const notificationStore = createStore(
  {name: 'notifications'},
  withProps<NotificationsState>(createInitialNotificationsState()),
);
